import fetchApi from "../utilities/fetch/httpService";
import apiUrls from "../utilities/consts/apiUrls";

export const getTeamService = () =>
  fetchApi({
    url: apiUrls.pages.team,
    method: "get",
  });

export const getCustomersService = () =>
  fetchApi({
    url: apiUrls.pages.customers,
    method: "get",
  });

export const getAboutService = () => getWebpageService("106");

export const getContactService = () => getWebpageService("105");

export const getWebpageService = (code) =>
  fetchApi({
    url: apiUrls.pages.webpage.replace("$code", code),
    method: "get",
  });

export const getNewsletterPageTitle = () => getPageTitle("2001");

export const getCustomersPageTitle = () => getPageTitle("2002");

export const getConsultingRequestPageTitle = () => getPageTitle("2003");

export const getJobRequestPageTitle = () => getPageTitle("2004");

export const getContactPageTitle = () => getPageTitle("2005");

export const getConsultingRequestModalTitle = () => getPageTitle("2006");

export const getLicenceNoticeTitle = () => getPageTitle("2007");

export const getCopyrightTitle = () => getPageTitle("2008");

export const getBrochureLink = () => getPageTitle("2009");
export const getTiTleContactUs = () => getPageTitle("2013");

export const getPageTitle = (code) =>
  fetchApi({
    url: apiUrls.pages.page_title.replace("$code", code),
    method: "get",
  });
